import {ChangeDetectionStrategy, Component, EventEmitter, Input, OnChanges, OnDestroy, OnInit, Output, SimpleChanges} from '@angular/core';
import {PlaningDate} from '../../../../../../projects/api/src/template/template.model';
import {NEW_PLANING_DATE_ID} from './planing-date-block.const';
import {DateTimeAdapter} from '@danielmoncada/angular-datetime-picker';
import {LocaleService} from '../../../../shared/services/locale.service';
import {TranslateService} from '@ngx-translate/core';
import {Subscription} from 'rxjs';


@Component({
    selector: 'app-planing-date-block',
    templateUrl: './planing-date-block.component.html',
    styleUrls: ['./planing-date-block.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: false
})
export class PlaningDateBlockComponent implements OnInit, OnChanges, OnDestroy {
  @Input() idx: number;
  @Input() planingDate: PlaningDate;
  @Output() planingDateChange = new EventEmitter<PlaningDate>();
  @Output() removePlaningDate = new EventEmitter<any>();
  @Output() addPlaningDate = new EventEmitter<any>();
  @Output() show: EventEmitter<any> = new EventEmitter();
  @Output() hide: EventEmitter<any> = new EventEmitter();
  public repeatLabels = [
    {label: 'Once', value: false},
    {label: 'Yearly', value: true}
  ];
  dateRange = [];
  subscription: Subscription;
  readonly NEW_PLANING_DATE_ID = NEW_PLANING_DATE_ID;

  constructor(private dateTimeAdapter: DateTimeAdapter<Date>,
              private translate: TranslateService,
              private localeService: LocaleService) {
    this.subscription = localeService.locale$.subscribe(locale => {
      dateTimeAdapter.setLocale(locale.serverShort);
    });
  }

  ngOnInit() {
    return;
  }

  ngOnDestroy(): void {
    this.subscription.unsubscribe();
  }

  ngOnChanges(changes: SimpleChanges): void {
    this.dateRange = [];
    if (this.planingDate.datefrom && this.planingDate.dateto) {
      this.dateRange = [new Date(this.planingDate.datefrom), new Date(this.planingDate.dateto)];
    }
  }


  translateButtons() {
    this.repeatLabels[0].label = this.translate.instant('Once');
    this.repeatLabels[1].label = this.translate.instant('Yearly');
    return this.repeatLabels;
  }
  updateDateRange() {
    if (this.dateRange[0] === null || this.dateRange[1] === null) {
      this.removePlaningDate.next(this.idx);
      return;
    }
    const timeZoneInSec = new Date().getTimezoneOffset();
    this.planingDate.datefrom = this.dateRange[0].getTime() - (60 * 1000 * timeZoneInSec);
    this.planingDate.dateto = this.dateRange[1].getTime() - (60 * 1000 * timeZoneInSec);
    this.addPlaningDate.next(this.planingDate);
  }
}
